<template>
  <div class="bill-page">
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <KTCodePreview v-bind:title="getPageTitle()">
      <template v-slot:toolbar>
        <b-row class="align-items-center">
          <b-button
            variant="primary"
            size="sm"
            class="mr-2 font-weight-bolder"
            @click="createIndependentRefund"
          >
            <i class="fas fa-plus"></i>
            Tạo phiếu trả hàng độc lập
          </b-button>
          <b-dropdown size="sm" id="dropdown-1" right>
            <template slot="button-content">
              <i style="font-size: 1rem" class="fas fa-cog"></i>
              <span class="font-weight-bolder">Thao tác</span>
            </template>
            <b-dropdown-item @click="showModalExcel">
              <span>
                <i style="font-size: 1rem" class="far fa-file-excel"></i>
                &nbsp; Xuất Excel</span
              >
            </b-dropdown-item>
          </b-dropdown>
        </b-row>
      </template>
      <template v-slot:preview>
        <RefundBillFilter
          @filter="onClickFilter"
          @update-filter="updateFilter"
        />
        <b-row>
          <b-col cols="9">
            <p class="mt-2 text-dark" style="font-weight: 500">
              Tổng số:
              {{ convertPrice(totalItems) }}
            </p>
          </b-col>
          <b-col cols="3">
            <div>
              <b-pagination-nav
                pills
                size="sm"
                v-show="totalPages >= 2"
                :number-of-pages="totalPages"
                :link-gen="linkGen"
                align="right"
                v-model="page"
                use-router
                @change="fetchListBill()"
                class="mt-3"
                style="border-radius: 5px"
              ></b-pagination-nav>
            </div>
          </b-col>
        </b-row>
        <div class="list-bill">
          <table class="table table-bordered-list table-hover col-md-12">
            <thead>
              <tr>
                <th class="text-center tdCode">
                  <div class="d-flex align-items-center justify-content-center">
                    <b-form-checkbox
                      :checked="isAllPageSelected"
                      :indeterminate="isIndeterminate"
                      @change="onToggleSelectAll"
                      class="mr-2"
                      v-b-tooltip.hover
                      title="Chọn tất cả trên trang này"
                    />
                    ID
                  </div>
                </th>
                <th class="text-center tdProductName">Sản phẩm</th>
                <th class="text-center tdProductPrice">Giá</th>
                <th class="text-center tdQuantity">SL</th>
                <th class="text-center tdDiscountItem">C.Khấu</th>
                <th class="text-center tdTotalAmount">Tổng tiền</th>
                <th class="text-center tdTotalPayment">Thanh toán</th>
                <th class="text-center tdNote">Ghi chú</th>
                <th class="tdAction"></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(bill, i) in bills">
                <tr
                  :key="i"
                  @mouseover="hoverRow"
                  @mouseleave="outRow"
                  :data="`row_${bill.billNumber}`"
                >
                  <td
                    colspan="6"
                    style="
                      padding: 5px !important;
                      border-bottom: none !important;
                    "
                  >
                    <div class="d-flex align-items-start">
                      <b-form-checkbox
                        v-model="selectedBillIds"
                        :value="bill.id"
                        class="mr-2 mt-1"
                        v-b-tooltip.hover
                        title="Chọn để tạo điều chỉnh GTGT"
                      />
                      <div class="flex-grow-1">
                      <div class="customer-header-info">
                        <small class="text-muted">Chi nhánh:</small>
                        <span>
                          <b>{{ bill.storeName }}</b>
                          <span
                            class="ml-1 text-muted"
                            v-if="bill.companyName"
                            style="font-size: 10px"
                            >( {{ bill.companyName }} )</span
                          >
                        </span>
                        <AdjustmentEInvoiceStatusBadge
                          v-if="bill.adjustmentEinvoice"
                          class="ml-2"
                          :status="bill.adjustmentEinvoice.status"
                          :invoice-no="bill.adjustmentEinvoice.invoiceNo"
                          :pattern="bill.adjustmentEinvoice.pattern"
                          :serial="bill.adjustmentEinvoice.serial"
                          :tax-status="bill.adjustmentEinvoice.taxStatus"
                          :issued-at="bill.adjustmentEinvoice.issuedAt"
                          :error-message="bill.adjustmentEinvoice.errorMessage"
                          :draft-code="bill.adjustmentEinvoice.draftCode"
                          size="sm"
                          @click="viewAdjustmentDraft(bill.adjustmentEinvoice.draftId)"
                        />
                      </div>
                      <div class="customer-header-info">
                        <small class="text-muted">KH/CTY:</small>
                        <span class="customer-header-info__values">
                          <span
                            class="customer-name orderCode cursor-pointer"
                            @click="editUser(bill)"
                          >{{ bill.customerName }}</span>
                          <span
                            class="customer-mobile orderCode cursor-pointer"
                            @click="editUser(bill)"
                          >{{ bill.customerMobile }}</span>
                        </span>
                      </div>

                    <div class="d-flex bill-header-meta">
                      <span class="mr-4">
                        <small class="text-muted">Ngày tạo: </small>
                        <span class="text-primary">{{ bill.createdAt }}</span>
                      </span>
                      <span v-if="bill.originalBill?.createdAt" class="mr-4">
                        <small class="text-muted">Ngày HĐ gốc: </small>
                        <span class="text-primary">{{ convertToDateSlash(bill.originalBill?.createdAt) }}</span>
                      </span>
                      <span class="mr-4">
                        <small class="text-muted">TVBH:</small>
                        <span v-if="bill.saleName">{{ bill.saleName }}</span>
                        <span v-else class="text-danger"> Chưa được gán </span>
                      </span>
                      <span class="mr-4">
                        <small class="text-muted">NVTN:</small>
                        <span v-if="bill.cashierName">{{ bill.cashierName }}</span>
                        <span v-else class="text-danger"> Chưa được gán </span>
                      </span>
                      <span class="mr-4">
                        <small class="text-muted">NVKT:</small>
                        <span v-if="bill.technicalName">{{ bill.technicalName }}</span>
                        <span v-else class="text-danger"> Chưa được gán </span>
                      </span>
                      <span class="mr-4" v-if="bill.stockSlipId">
                        <span class="mr-1"
                          ><i
                            v-b-tooltip.hover
                            title="Đã liên kết phiếu thu cũ"
                            style="color: #50cd89"
                            class="fa fa-link"
                          ></i
                        ></span>
                      </span>
                      <span v-if="billAdjustmentStatus[bill.id]" class="mr-4">
                        <span class="mr-1 text-muted" style="font-size:0.8rem">HĐĐT ĐC:</span>
                        <AdjustmentStatusBadge :status="billAdjustmentStatus[bill.id].status" />
                        <a
                          class="ml-1"
                          style="font-size:0.8rem; cursor:pointer"
                          @click="viewAdjustmentDraft(billAdjustmentStatus[bill.id].draftId)"
                        >({{ billAdjustmentStatus[bill.id].draftCode }})</a>
                      </span>
                    </div>
                    </div>
                    </div>
                  </td>
                  <td style="border-bottom: none !important" colspan="2">
                    <b-row>
                      <b-col cols="10">
                        <div class="d-flex" style="font-size: 0.87rem">
                          <span v-if="bill.couponCode">
                            Mã coupon: {{ bill.couponCode }}
                          </span>
                        </div>
                      </b-col>
                      <b-col cols="2" class="text-right">
                        <i
                          class="fa fa-arrow-circle-o-down"
                          aria-hidden="true"
                        ></i>
                      </b-col>
                    </b-row>
                  </td>
                  <td
                    style="border-bottom: none !important"
                    class="text-center"
                  >
                    <!-- <i
                      class="fa fa-download text-primary cursor-pointer"
                      aria-hidden="true"
                      @click="openFileModal(bill)"
                      v-if="billType !== BILL_TYPE.CONVERT"
                    ></i> -->
                  </td>
                </tr>
                <tr :key="i + 10" v-if="bill.showDetail">
                  <td colspan="9" style="border-bottom: none !important">
                    <b-col cols="3"></b-col>
                  </td>
                </tr>
                <template v-for="(billItem, j) in bill.listProduct">
                  <tr
                    v-if="j < limitListProduct"
                    :key="i + j + billItem.id"
                    @mouseover="hoverBill"
                    @mouseleave="outBill"
                    :data="`row_${bill.billNumber}`"
                  >
                    <td
                      :rowspan="
                        bill.listProduct.length > limitListProduct
                          ? limitListProduct
                          : bill.listProduct.length
                      "
                      v-if="j === 0 || bill.show"
                      class="tdTextAlign tdCode"
                    >
                      <div class="text-center mb-2">
                        <span
                          title="Từ app mobile"
                          v-b-tooltip
                          v-if="bill.deviceType === 2"
                        >
                          <i class="fas fa-mobile-alt text-dark ml-1"></i>
                        </span>
                        <span
                          title="Từ web"
                          v-b-tooltip
                          v-else-if="bill.deviceType === 1"
                        >
                          <i class="fas fa-globe-asia text-dark"></i>
                        </span>
                        <span title="Chưa xác định" v-b-tooltip v-else>
                          <i
                            class="fa fa-stop-circle text-danger"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </div>
                      <div
                        class="orderCode"
                        style="cursor: pointer; color: #3699ff"
                      >
                        <a
                          class="font-weight-bold"
                          v-bind:href="getByType('router-link-id', bill)"
                          target="_self"
                        >
                          {{ bill.billNumber }}
                        </a>
                      </div>
                      <div v-if="bill.returnFromBillNumber" class="text-center">
                        <span class="text-warning"
                          ><i
                            class="fas fa-shopping-basket"
                            title="Trả hàng từ hóa đơn"
                          ></i
                        ></span>
                        <div
                          class="orderCode"
                          @click="linkToBill(bill)"
                          style="cursor: pointer"
                        >
                          <span
                            style="color: darkgoldenrod"
                            v-text="bill.returnFromBillNumber"
                          ></span>
                        </div>
                      </div>
                    </td>
                    <td class="tdTextAlign tdProductName">
                      <div v-if="billItem.typeProduct !== 3">
                        <div class="d-flex align-items-center flex-gap-8">
                          <!-- Product Image -->
                          <ProductImage
                            :src="billItem.imageUrl"
                            class="size-40 object-contain flex-shrink-0"
                          />

                          <!-- Product Information -->
                          <div class="product-info flex-grow-1 min-w-0">
                            <!-- Top: barCode + productCode -->
                            <div class="product-codes">
                              <span v-if="billItem.barCode" class="code-text">
                                {{ billItem.barCode }}
                              </span>
                              <br />
                              <span v-if="billItem.productCode" class="code-text">
                                ({{ billItem.productCode }})
                              </span>
                            </div>

                            <!-- Middle: product name + type icon -->
                            <div class="product-title">
                              <i
                                v-if="billItem.productType === 2"
                                class="fas fa-gift product-icon gift"
                                title="Quà tặng"
                              ></i>
                              <i
                                v-else-if="billItem.productType === 3"
                                class="fas fa-tags product-icon attach"
                                title="Bán kèm"
                              ></i>
                              <span class="product-name">{{
                                billItem.productName
                              }}</span>
                            </div>

                            <!-- Bottom: IMEI nếu có -->
                            <div
                              v-if="
                                billItem.imeiCode &&
                                billItem.imeiCode.trim() !== ''
                              "
                              class="product-meta"
                            >
                              <ImeiDisplay :imei="billItem.imeiCode" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          class="table-responsive"
                          v-show="
                            billItem.comboItems !== undefined &&
                            billItem.comboItems.length > 0
                          "
                        >
                          <table>
                            <tr>
                              <td style="border: none; padding-left: 0">
                                <p class="m-0">
                                  {{ billItem.productName }}
                                  <!-- <MerchantLabel
                                    :merchantId="billItem.merchantId"
                                  /> -->
                                </p>
                              </td>
                            </tr>
                            <tr
                              v-for="(items, i) in billItem.comboItems"
                              :key="i"
                              style="border-top: 1px solid gray"
                            >
                              <td
                                style="
                                  border: none;
                                  width: -webkit-fill-available;
                                "
                              >
                                <i
                                  style="color: rgb(24, 28, 50)"
                                  class="fas fa-cube"
                                ></i>
                                {{ items.productName }}
                                <!-- <MerchantLabel
                                  :merchantId="billItem.merchantId"
                                /> -->
                                <i style="font-size: unset; color: unset"
                                  >({{ convertPrice(items.sellingPrice) }})</i
                                >
                              </td>
                              <td style="border: none; font-size: 13px">
                                {{ items.quantity }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </td>
                    <td class="tdTextAlignPrice tdProductPrice">
                      {{ convertPrice(billItem.productPrice) }}
                    </td>
                    <td class="tdTextAlignPrice tdQuantity">
                      {{ billItem.quantity }}
                    </td>
                    <td class="tdTextAlignPrice tdDiscountItem">
                      <p v-if="billItem.discountType === 1">
                        {{ convertPrice(billItem.discount) }}
                      </p>
                      <p
                        v-if="
                          billItem.discountType === 2 && billItem.discount > 0
                        "
                      >
                        {{ convertPrice(billItem.discount) }}%
                        <br />
                        <span style="color: #ffa800; font-style: italic">
                          {{ convertPrice(billItem.discountItemAmount) }}</span
                        >
                      </p>
                      <p
                        v-if="
                          billItem.discountType === 2 && billItem.discount === 0
                        "
                      >
                        {{ convertPrice(billItem.discount) }}
                      </p>
                    </td>
                    <td
                      class="tdTextAlignPrice tdTotalAmount"
                      :rowspan="
                        bill.listProduct.length > limitListProduct
                          ? limitListProduct
                          : bill.listProduct.length
                      "
                      v-if="j === 0 || bill.show"
                    >
                      <p v-show="bill.refundFee > 0" class="border-0">
                        <img
                          v-b-tooltip.hover
                          title="Tổng tiền hàng"
                          src="/media/svg/icons/Shopping/Money.svg"
                          class="icon-color mr-1"
                          alt="Tổng tiền hàng"
                          width="18"
                          height="18"
                        />
                        : {{ convertPrice(bill.totalAmount + bill.refundFee) }}
                      </p>
                      <p v-show="bill.refundFee > 0" class="border-0">
                        <img
                          v-b-tooltip.hover
                          title="Phí trả hàng"
                          src="/media/svg/icons/Shopping/Dollar.svg"
                          class="icon-color mr-1"
                          alt="Phí trả hàng"
                          width="16"
                          height="16"
                        />
                        : {{ convertPrice(bill.refundFee) }}
                      </p>
                      <p
                        v-show="
                          bill.discountAmount > 0 ||
                          bill.discountAmount.includes('%') ||
                          bill.discountAmount.includes('.')
                        "
                        class="border-0 text-warning"
                      >
                        <i
                          v-b-tooltip.hover
                          title="Chiết khấu tổng"
                          class="fa fa-arrow-down icon-color"
                        ></i>
                        : {{ bill.discountAmount }}
                      </p>
                      <b style="color: #3c763d">
                        {{ convertPrice(bill.totalAmount) }}</b
                      >
                    </td>
                    <td
                      class="tdTextAlignPrice tdTotalPayment"
                      :rowspan="
                        bill.listProduct.length > limitListProduct
                          ? limitListProduct
                          : bill.listProduct.length
                      "
                      v-if="j === 0 || bill.show"
                    >
                      <p v-show="bill.pointToMoney > 0" class="border-0">
                        <i
                          v-b-tooltip.hover
                          title="Tiêu điểm"
                          class="fas fa-adjust icon-color"
                        ></i>
                        : {{ convertPrice(bill.pointToMoney) }}
                      </p>
                      <template v-if="bill.payments && bill.payments.length">
                        <div
                          v-for="(payment, index) in bill.payments"
                          :key="index"
                          class="mb-2"
                        >
                          <span class="mr-2">
                            <i
                              v-b-tooltip.hover
                              :title="payment.paymentName"
                              class="icon-color text-dark mr-1"
                              :class="
                                payment.paymentType === 1
                                  ? 'fas fa-money-bill-alt'
                                  : payment.paymentType === 2
                                    ? 'fa fa-university'
                                    : payment.paymentType === 3
                                      ? 'fa fa-credit-card'
                                      : payment.paymentType === 4
                                        ? 'fa fa-cube'
                                        : ''
                              "
                            ></i
                            >:
                          </span>
                          <span style="font-weight: 700">{{
                            convertPrice(payment.paymentAmount)
                          }}</span>
                        </div>
                      </template>
                      <p v-show="bill.conversionFee > 0" class="border-0">
                        <i
                          v-b-tooltip.hover
                          title="Thanh toán phí chuyển đổi"
                          class="fa-solid fa-money-bill-transfer icon-color text-dark"
                        ></i>
                        : {{ convertPrice(bill.conversionFee) }}
                      </p>
                      <p
                        v-if="bill.extraAmount > 0"
                        class="d-block text-primary"
                      >
                        Tiền thừa:
                        <span class="d-block">{{
                          convertPrice(bill.extraAmount)
                        }}</span>
                      </p>
                      <p
                        v-if="bill.extraAmount < 0"
                        class="d-block"
                        style="color: #e65b5b"
                      >
                        Còn thiếu:
                        <span class="d-block">
                          {{ convertPrice(bill.extraAmount * -1) }}</span
                        >
                      </p>
                      <p v-show="bill.leftAmount > 0">
                        Công nợ:
                        <span class="d-block">
                          {{ convertPrice(bill.leftAmount) }}</span
                        >
                      </p>
                    </td>
                    <td
                      class="tdTextAlign tdNote wrapword"
                      :rowspan="
                        bill.listProduct.length > limitListProduct
                          ? limitListProduct
                          : bill.listProduct.length
                      "
                      v-if="j === 0 || bill.show"
                      @mouseover="hoverPrice = true"
                      @mouseleave="hoverPrice = false"
                    >
                      <p
                        v-if="bill.customerNote"
                        :title="bill.customerNote"
                        v-b-tooltip.hover
                      >
                        {{ truncateText(bill.customerNote) }}
                      </p>
                      <p
                        v-if="bill.customerNote && bill.warrantyNote"
                        class="dashed"
                      ></p>
                      <p
                        v-if="bill.warrantyNote"
                        :title="bill.warrantyNote"
                        v-b-tooltip.hover
                      >
                        {{ truncateText(bill.warrantyNote) }}
                      </p>
                      <span @click="handleShowNoteModel(bill)">
                        <i class="fas fa-edit cursor-pointer"></i>
                      </span>
                    </td>
                    <td
                      :rowspan="
                        bill.listProduct.length > limitListProduct
                          ? limitListProduct
                          : bill.listProduct.length
                      "
                      v-if="j === 0 || bill.show"
                      class="tdTextAlign tdAction"
                    >
                      <div
                        class="d-flex justify-content-center"
                        v-if="billType !== BILL_TYPE.CONVERT"
                      >
                        <b-dropdown size="sm" id="dropdown-left" no-caret right>
                          <template slot="button-content">
                            <i class="flaticon2-settings function-btn"></i>
                          </template>
                          <b-dropdown-item @click="editItem(bill)">
                            <span style="color: #3f4254; font-size: 12px">
                              <i
                                style="font-size: 1rem"
                                class="flaticon2-pen"
                              ></i>
                              &nbsp; Chỉnh sửa
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="
                              showApprovalModal(
                                bill,
                                APPROVAL_PAYMENT_TYPE.CASH,
                              )
                            "
                            v-if="isShowCashApproval(bill)"
                          >
                            <span style="color: #3f4254; font-size: 12px">
                              <i
                                style="font-size: 1rem"
                                class="fas fa-money-bill-alt"
                              ></i>
                              &nbsp; Hoàn tiền mặt
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="
                              showApprovalModal(
                                bill,
                                APPROVAL_PAYMENT_TYPE.TRANSFER,
                              )
                            "
                            v-if="isShowTransferApproval(bill)"
                          >
                            <span style="color: #3f4254; font-size: 12px">
                              <i
                                style="font-size: 1rem"
                                class="fas fa-exchange-alt"
                              ></i>
                              &nbsp; Hoàn tiền chuyển khoản
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item @click="goToAdjustmentWizardSingle(bill)">
                            <span style="font-size: 12px">
                              <i style="font-size: 1rem" class="fas fa-file-invoice"></i>
                              &nbsp; Tạo điều chỉnh GTGT
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item v-if="checkPermission('BILL_DELETE')" @click="showDeleteAlert(bill)">
                            <span style="color: #3f4254; font-size: 12px">
                              <i
                                style="font-size: 1rem; color: #d33"
                                class="flaticon2-rubbish-bin-delete-button"
                              ></i>
                              &nbsp; Xóa
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-divider />
                          <b-dropdown-item
                            v-if="billAdjustmentStatus[bill.id]"
                            @click="viewAdjustmentDraft(billAdjustmentStatus[bill.id].draftId)"
                          >
                            <span style="color: #3699FF; font-size: 12px">
                              <i style="font-size: 1rem" class="fas fa-eye"></i>
                              &nbsp; Xem nháp điều chỉnh
                            </span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
            <tfoot>
              <tr v-if="!onLoading">
                <td :colspan="3" class="tdTextAlignPrice text-weight">Tổng</td>
                <td class="tdTextAlignPrice text-weight">
                  {{ convertPrice(totalQuantity) }}
                </td>
                <td></td>
                <td class="tdTextAlignPrice text-weight">
                  {{ convertPrice(totalAmount) }}
                </td>
                <td class="tdTextAlignPrice text-weight">
                  {{ convertPrice(totalPayment) }}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
          <vcl-table
            v-if="onLoading"
            :speed="5"
            :animate="true"
            :columns="11"
          ></vcl-table>
          <b-row>
            <b-col cols="9">
              <p class="mt-4 text-dark" style="font-weight: 500">
                Tổng số:
                {{ convertPrice(totalItems) }}
              </p>
            </b-col>
            <b-col cols="3">
              <div>
                <b-pagination-nav
                  pills
                  size="sm"
                  v-show="totalPages >= 2"
                  :number-of-pages="totalPages"
                  :link-gen="linkGen"
                  align="right"
                  v-model="page"
                  use-router
                  @change="fetchListBill()"
                  class="mt-3"
                  style="border-radius: 5px"
                ></b-pagination-nav>
              </div>
            </b-col>
          </b-row>
          <template>
            <b-modal
              v-model="showEditNoteModal"
              hide-footer
              :titleHtml="titleNoteModal"
            >
              <b-row class="mb-5">
                <b-col>
                  <label class="labelInput" for="inputOriginalPrice"
                    >Ghi chú bán hàng</label
                  >
                  <b-form-textarea
                    v-model="customerNote"
                    placeholder="Nhập ghi chú..."
                    rows="5"
                    max-rows="6"
                  ></b-form-textarea>
                </b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col>
                  <label class="labelInput" for="inputOriginalPrice"
                    >Ghi chú bảo hành</label
                  >
                  <b-form-textarea
                    v-model="warrantyNote"
                    placeholder="Nhập ghi chú..."
                    rows="5"
                    max-rows="6"
                  ></b-form-textarea>
                </b-col>
              </b-row>
              <b-row d-flex justify-content-end>
                <b-col>
                  <b-button
                    class="edit-note-btn"
                    variant="primary"
                    size="sm"
                    @click="updateNote"
                    >Lưu
                  </b-button>
                  <b-button
                    variant="secondary"
                    class="ml-2"
                    size="sm"
                    @click="handleShowNoteModel"
                    >Hủy
                  </b-button>
                </b-col>
              </b-row>
            </b-modal>
          </template>
          <template>
            <BillExcel :param="apiParams" :mode="billType" />
          </template>
        </div>
      </template>
    </KTCodePreview>

    <ApprovalModal ref="popup-approval" />

    <transition name="selection-panel-slide">
      <div v-if="selectedBillIds.length > 0" class="selection-panel">
        <div class="selection-panel-inner">
          <div class="selection-label">
            <i class="fas fa-check-square mr-1"></i>
            Đã chọn <strong>{{ selectedBillIds.length }}</strong> phiếu:
          </div>
          <div class="selection-tags-wrap">
            <span
              v-for="billId in selectedBillIds"
              :key="billId"
              class="selection-tag"
            >
              {{ getBillNumberById(billId) }}
              <i class="fas fa-times ml-1" @click="removeBillSelection(billId)"></i>
            </span>
          </div>
          <div class="selection-actions">
            <b-button
              size="sm"
              variant="outline-secondary"
              class="mr-2"
              @click="selectedBillIds = []"
            >
              <i class="fas fa-times mr-1"></i>
              Bỏ chọn tất cả
            </b-button>
            <b-button
              size="sm"
              variant="warning"
              class="font-weight-bold"
              @click="goToAdjustmentWizard"
            >
              <i class="fas fa-file-invoice mr-1"></i>
              Tạo điều chỉnh GTGT
            </b-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import Loader from '@/view/content/Loader.vue';
import Swal from 'sweetalert2';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import {
  BILL_TYPE,
  APPROVAL_TYPE_ENUM,
  APPROVAL_PAYMENT_TYPE,
  RETURN_BILL_ADJUSTMENT_LIST_FILTER,
} from '@/utils/enum';
import jQuery from 'jquery';
import ApiService from '@/core/services/api.service';
import { mapGetters } from 'vuex';
import RefundBillFilter from '@/view/components/bills/RefundBillFilter.vue';
import { makeToastFaile, makeToastSuccess, handleError } from '@/utils/common';
import { validateBillProductSearchInput } from '@/utils/productSearch';
import { convertPrice, truncateText } from '@/utils/common';
import { VclTable } from 'vue-content-loading';
import _sumBy from 'lodash/sumBy';
import _flatten from 'lodash/flatten';
import moment from 'moment';
import BillExcel from '@/view/components/bills/BillExcel.vue';
import ApprovalModal from '@/view/components/approval/ApprovalModal.vue';
import ImeiDisplay from '@/view/components/imeis/ImeiDisplay.vue';
import ProductImage from '@/view/components/products/ProductImage.vue';
import AdjustmentStatusBadge from '@/view/pages/einvoice/adjustment/components/AdjustmentStatusBadge.vue';
import AdjustmentEInvoiceStatusBadge from '@/view/components/bills/AdjustmentEInvoiceStatusBadge.vue';
import permissionMixin from '@/view/mixins/permission.mixin'
import { convertToDateSlash } from '@/utils/date';

export default {
  mixins: [permissionMixin],
  props: {
    billType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      BILL_TYPE,
      bills: [],
      totalPages: 0,
      totalItems: 0,
      onLoading: false,
      page: 1,
      hoverTable: {
        dataId: null,
      },
      hoverPrice: false,
      limitListProduct: 10,
      idBill: '',
      showEditNoteModal: false,
      customerNote: '',
      warrantyNote: '',
      titleNoteModal: '',
      appliedFilterParams: {},
      apiParams: {},
      selectedBillIds: [],
      billAdjustmentStatus: {},
      APPROVAL_TYPE: APPROVAL_TYPE_ENUM,
      APPROVAL_PAYMENT_TYPE,
    };
  },
  components: {
    KTCodePreview,
    Loader,
    RefundBillFilter,
    VclTable,
    BillExcel,
    ApprovalModal,
    ImeiDisplay,
    ProductImage,
    AdjustmentStatusBadge,
    AdjustmentEInvoiceStatusBadge,
  },
  created() {
    // this.fetchListBill();
  },
  computed: {
    pageBillIds() {
      return this.bills.map((b) => b.id).filter(Boolean);
    },
    isAllPageSelected() {
      return (
        this.pageBillIds.length > 0 &&
        this.pageBillIds.every((id) => this.selectedBillIds.includes(id))
      );
    },
    isIndeterminate() {
      const selected = this.pageBillIds.filter((id) =>
        this.selectedBillIds.includes(id)
      );
      return selected.length > 0 && selected.length < this.pageBillIds.length;
    },
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
    totalQuantity: {
      get() {
        const flattenBillItems = _flatten(
          this.bills.map((bill) => bill.listProduct),
        );
        return _sumBy(flattenBillItems, 'quantity');
      },
      set(amount) {
        return amount;
      },
    },
    totalAmount: {
      get() {
        return _sumBy(this.bills, 'totalAmount');
      },
      set(amount) {
        return amount;
      },
    },
    totalPayment: {
      get() {
        return _sumBy(this.bills, 'paymentAmount');
      },
      set(amount) {
        return amount;
      },
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hóa đơn trả hàng', route: 'refund-bills' },
      { title: 'Danh sách hóa đơn trả hàng' },
    ]);
  },
  methods: {
    onToggleSelectAll(checked) {
      if (checked) {
        const toAdd = this.pageBillIds.filter(
          (id) => !this.selectedBillIds.includes(id)
        );
        this.selectedBillIds.push(...toAdd);
      } else {
        this.selectedBillIds = this.selectedBillIds.filter(
          (id) => !this.pageBillIds.includes(id)
        );
      }
    },
    convertToDateSlash,
    convertPrice,
    truncateText,
    linkGen: (pageNum) => {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    getPageTitle() {
      return 'Danh sách hóa đơn trả hàng';
    },
    // Mở màn tạo phiếu trả hàng độc lập (không tham chiếu hóa đơn bán gốc).
    createIndependentRefund() {
      this.$router.push({
        name: 'refund-bill',
        query: { independent: 1 },
      });
    },
    getByType(name, item) {
      switch (name) {
        case 'router-update': {
          return 'update-refund-bill';
        }
        case 'router-link-id': {
          const href =
            '#/refund-bills/update-refund-bill' +
            `?billNumber=${item.billNumber}`;
          return href;
        }
      }
    },
    hoverRow: function (evt) {
      const items = jQuery(evt.currentTarget);
      const dataId = jQuery(items[0]).attr('data');
      if (this.hoverTable.dataId !== dataId) {
        const rows = jQuery(`[data=${dataId}]`);
        rows.addClass('tr-rowspan-hover');
        this.hoverTable.dataId = dataId;
      }
    },
    outRow: function (evt) {
      const items = jQuery(evt.currentTarget);
      const dataId = jQuery(items[0]).attr('data');
      const rows = jQuery(`[data=${dataId}]`);
      rows.removeClass('tr-rowspan-hover');
      this.hoverTable.dataId = null;
    },
    hoverBill: function (evt) {
      const items = jQuery(evt.currentTarget);
      const dataId = jQuery(items[0]).attr('data');
      const rows = jQuery(`[data=${dataId}]`);
      rows.addClass('tr-rowspan-hover');
    },
    outBill: function (evt) {
      const items = jQuery(evt.currentTarget);
      const dataId = jQuery(items[0]).attr('data');
      const rows = jQuery(`[data=${dataId}]`);
      rows.removeClass('tr-rowspan-hover');
    },
    onFilter(queryParams) {
      // const isValidParam = this.validateParamSearch();
      // if (!isValidParam) {
      //   return;
      // }
      this.$route.query.page = 1;
      this.changeURL();
      this.fetchListBill(queryParams);
    },
    validateParamSearch() {
      const productValidationMessage = validateBillProductSearchInput(
        this.searchProductName,
        this.searchIMEI,
      );
      if (productValidationMessage) {
        makeToastFaile(productValidationMessage);
        return false;
      }
      const textSearchCoupon = this.searchCoupon
        ? this.searchCoupon.trim()
        : '';
      if (textSearchCoupon && textSearchCoupon.length < 5) {
        makeToastFaile('Vui lòng nhập tìm kiếm mã coupon trên 5 ký tự!');
        return false;
      }
      const textSearchNote = this.searchNote ? this.searchNote.trim() : '';
      if (textSearchNote && textSearchNote.length < 5) {
        makeToastFaile('Vui lòng nhập tìm kiếm ghi chú trên 5 ký tự!');
        return false;
      }
      return true;
    },
    changeURL() {
      this.$router.push({
        name: 'list-refund-bill',
        //query: queryObj,
      });
    },
    fetchListBill: async function (queryParams = null) {
      if (queryParams) {
        this.appliedFilterParams = { ...queryParams };
      }
      const filtersToApply =
        queryParams || this.appliedFilterParams || {};
      this.page = this.$route.query.page;
      if (!this.page) {
        this.page = 1;
      }
      const param = {
        page: this.page,
        limit: 10,
        type: 3,
        ...filtersToApply,
      };

      this.onLoading = true;
      ApiService.query('v1/bills', {
        params: param,
      })
        .then((response) => {
          const { data } = response.data;
          this.bills = [];
          this.totalPages = data.totalPage;
          this.totalItems = data.totalRow;
          this.totalQuantity = 0;
          this.totalAmount = 0;
          this.totalPayment = 0;
          this.bills = data.dataset.reduce((result, item) => {
            let discountAmount = '';
            if (item.discountType === 2) {
              discountAmount = item.discountAmount + '%';
            } else if (item.discountType === 1) {
              discountAmount = convertPrice(item.discountAmount) + '';
            }
            item.isShowReturnBill = item.canReturnBill;
            item.discountAmount = discountAmount;
            item.show = item.listProduct.length <= 0;
            item.showDetail = false;
            result.push(item);
            return result;
          }, []);
          this.onLoading = false;
          this.fetchBillsAdjustmentStatus();
        })
        .catch((error) => {
          this.onLoading = false;
          console.error('error: ', error);
          this.bills = [];
          this.totalItems = 0;
          this.totalPages = 0;
          handleError(error);
        });
    },
    isShowByType(type) {
      switch (type) {
        case 'recreate': {
          return this.billType === BILL_TYPE.RETAIL_INVOICE;
        }
        case 'create-warranty': {
          return this.billType === BILL_TYPE.RETAIL_INVOICE;
        }
        case 'invoice-vat': {
          return [
            BILL_TYPE.RETAIL_INVOICE,
            BILL_TYPE.WHOLESALE_INVOICE,
          ].includes(this.billType);
        }
      }
    },
    editItem: function (item) {
      const { href } = this.$router.resolve({
        name: this.getByType('router-update'),
        query: { billNumber: item.billNumber },
      });
      window.open(href, '_self');
    },
    onClickFilter(filterObject) {
      this.selectedBillIds = [];
      const queryParams = {
        billNumber: filterObject?.billId || '',
        returnFromBillNumber: filterObject?.returnFromBillNumber || '',
        customerPhoneSearch: filterObject?.customerPhoneSearch || '',
        storeIds: filterObject?.storeIds.map((store) => store.id) || [],
        productSearch: filterObject?.productSearch || '',
        imeiSearch: filterObject?.imeiSearch || '',
        criteriaIds:
          filterObject?.criteriaIds.map((criteria) => criteria.id) || [],
        type: this.billType,
        fromDate: filterObject?.fromDate
          ? moment(filterObject.fromDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        toDate: filterObject?.toDate
          ? moment(filterObject.toDate, 'DD/MM/YYYY HH:mm').format(
              'yyyy-MM-DD 23:59',
            )
          : null,
        adjReturnBillStatus:
          filterObject?.adjReturnBillStatus != null &&
          String(filterObject.adjReturnBillStatus).trim() !== ''
            ? String(filterObject.adjReturnBillStatus).trim()
            : RETURN_BILL_ADJUSTMENT_LIST_FILTER.NO_ADJUSTMENT,
        hasAdjustEinvoice: filterObject?.hasAdjustEinvoice,
      };
      this.onFilter(queryParams);
    },
    handleShowNoteModel(item) {
      this.showEditNoteModal = !this.showEditNoteModal;
      this.idBill = item.billNumber;
      this.customerNote = item.customerNote;
      this.warrantyNote = item.warrantyNote;
      this.titleNoteModal = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Sửa ghi chú cho hóa đơn: <a class='text-primary'>#${this.idBill}</a></span>
              </div>`;
    },
    updateNote() {
      const payload = {
        billNumber: this.idBill,
        customerNote: this.customerNote,
        warrantyNote: this.warrantyNote,
      };
      ApiService.put('v1/bills/note', payload)
        .then(({ data }) => {
          makeToastSuccess(data.message);
          this.showEditNoteModal = false;
          this.fetchListBill();
        })
        .catch(({ response }) => {
          makeToastFaile(response.$error);
        });
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa hóa đơn!',
        text: 'Bạn có chắc muốn xóa hóa đơn này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      }).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },
    deleteItem: async function (item) {
      ApiService.delete('v1/bills/refund' + '/' + item.billNumber)
        .then((data) => {
          const { message } = data.data;
          makeToastSuccess(message);
          this.fetchListBill();
        })
        .catch((err) => {
          makeToastFaile(err.response.data.message);
        });
    },
    updateFilter(newVal) {
      this.apiParams = {
        billNumber: newVal?.billId || '',
        returnFromBillNumber: newVal?.returnFromBillNumber || '',
        customerPhoneSearch: newVal?.customerPhoneSearch || '',
        storeIds: newVal?.storeIds?.map((store) => store.id) || [],
        productSearch: newVal?.productSearch || '',
        imeiSearch: newVal?.imeiSearch || '',
        criteriaIds: newVal?.criteriaIds?.map((criteria) => criteria.id) || [],
        type: this.billType,
        fromDate: newVal?.fromDate
          ? moment(newVal.fromDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        toDate: newVal?.toDate
          ? moment(newVal.toDate, 'DD/MM/YYYY HH:mm').format('yyyy-MM-DD 23:59')
          : null,
        adjReturnBillStatus:
          newVal?.adjReturnBillStatus != null &&
          String(newVal.adjReturnBillStatus).trim() !== ''
            ? String(newVal.adjReturnBillStatus).trim()
            : RETURN_BILL_ADJUSTMENT_LIST_FILTER.NO_ADJUSTMENT,
        hasAdjustEinvoice: newVal?.hasAdjustEinvoice,
      };
    },
    showModalExcel() {
      this.$bvModal.show('modal-bill-excel');
    },
    printBill: async function (item) {
      let routeData = this.$router.resolve({
        name: 'print-bill',
        query: { id: item.billNumber },
      });
      window.open(routeData.href, '_self');
    },
    isShowCashApproval(bill) {
      return bill.cashAmount > 0;
    },
    isShowTransferApproval(bill) {
      return bill.transferAmount > 0;
    },
    editUser(item) {
      this.$router.push({
        name: 'update-customer',
        query: { id: item.customerId, phoneNo: item.customerMobile },
      });
    },
    showApprovalModal(bill, paymentType) {
      const data = {
        amount:
          paymentType === APPROVAL_PAYMENT_TYPE.CASH
            ? bill.cashAmount
            : bill.transferAmount,
        customerId: bill.customerId,
        customerName: bill.customerName,
        customerMobile: bill.customerMobile,
        storeId: bill.storeId,
        paymentType: paymentType,
      };
      this.$refs['popup-approval'].showModal(
        bill.billNumber,
        data,
        APPROVAL_TYPE_ENUM.REFUND,
      );
    },
    async fetchBillsAdjustmentStatus() {
      if (!this.bills || !this.bills.length) return;
      try {
        const returnBillIds = this.bills.map((b) => b.id).filter(Boolean);
        const { data } = await ApiService.post('v1/invoice-adjustment-drafts/bills-status', { returnBillIds });
        this.billAdjustmentStatus = data.data || data || {};
      } catch (e) {
        // silent — adjustment status is supplementary info
      }
    },
    goToAdjustmentWizard() {
      const validIds = this.selectedBillIds.filter(
        (id) => id != null && String(id).trim() !== ''
      );
      if (!validIds.length) return;
      this.$router.push({
        name: 'adjustment-wizard',
        query: { returnBillIds: validIds.map(String) },
      });
    },
    goToAdjustmentWizardSingle(bill) {
      if (!bill.id) {
        console.warn('[List] goToAdjustmentWizardSingle: bill.id is missing', bill);
        return;
      }
      this.$router.push({
        name: 'adjustment-wizard',
        query: { returnBillIds: [String(bill.id)] },
      });
    },
    viewAdjustmentDraft(draftId) {
      this.$router.push({ name: 'adjustment-draft-detail', params: { draftId } });
    },
    getBillNumberById(id) {
      const bill = this.bills.find((b) => b.id === id);
      return bill ? bill.billNumber : id;
    },
    removeBillSelection(id) {
      this.selectedBillIds = this.selectedBillIds.filter((bid) => bid !== id);
    },
    linkToBill: function (item) {
      let nameRouter = '';
      if (item.returnFromBillType === 1) {
        nameRouter = 'update-bill';
      } else if (item.returnFromBillType === 2) {
        nameRouter = 'update-wholesale-invoice';
      }
      const { href } = this.$router.resolve({
        name: nameRouter,
        query: { id: item.returnFromBillNumber },
      });
      window.open(href, '_blank');
    },
  },
};
</script>

<style scoped>
.orderCode:hover {
  text-decoration: underline;
}

.table th,
.table td {
  vertical-align: middle;
}

.tdTextAlign {
  vertical-align: middle;
}

.tdTextAlignPrice {
  text-align: right !important;
  vertical-align: middle;
}

.table-bordered-list th {
  border: 0.5px solid #d2d4d6 !important;
  background-color: #e0e0e0;
}

.table-bordered-list td {
  border: 0.5px solid #f3f3f3;
  /* border: 0.5px solid #fdfbfb; */
  /* border: 0.5px solid #d5d5d5; */
  border-bottom: 0.5px solid #adadad;
}

.text-weight {
  font-weight: 550;
}

.font-size-gift {
  font-size: 11px;
}

.font-size-attach {
  font-size: 11px;
}

.tdCode {
  width: 5%;
}

.tdCustomer {
  width: 7%;
}

.tdProductName {
  width: 38%;
}

.tdProductPrice {
  width: 8%;
}

.tdQuantity {
  width: 3%;
}

.tdDiscountItem {
  width: 5%;
}

.tdTotalAmount {
  width: 8%;
}

.tdTotalPayment {
  width: 12%;
  font-weight: 700;
}

.tdNote {
  width: 8%;
}

.tdAction {
  width: 1%;
  max-width: 56px;
  min-width: 52px;
  padding: 2px 0 !important;
  white-space: nowrap;
}

.search-col {
  display: flex;
  align-items: center;
}
</style>

<style lang="scss" scoped>
.bill-page ::v-deep {
  .bill-header-meta {
    font-size: 0.87rem;
  }

  .customer-header-info {
    margin-bottom: 2px;
    font-size: 0.87rem;
    line-height: 1.35;

    > small.text-muted {
      margin-right: 4px;
    }
  }

  .customer-header-info__values {
    .customer-name {
      margin-right: 6px;
    }
  }

  .customer-header-info .customer-name {
    font-size: 0.87rem;
    font-weight: 700;
    color: #3699ff;
  }

  .customer-header-info .customer-mobile {
    font-size: 0.87rem;
    font-weight: 600;
    color: #464e5f;
  }

  .select-style {
    border-radius: 0.28rem;
    box-shadow: none;
    border: 1px solid #ced4da;
  }

  input.form-control {
    border: 1px solid #ced4da;
  }

  .dashed {
    border: 1px dashed #464e5f;
    border-style: none none dashed;
    color: #fff;
    background-color: #fff;
  }

  .filter-btn {
    font-weight: 600;
    width: 70px;
  }

  .function-btn {
    font-size: 1rem;
    padding-right: 0;
  }

  .edit-note-btn {
    font-weight: 600;
    width: 70px;
  }

  .product-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .product-codes {
    font-size: 12px;
    color: #475569; /* xám nhẹ */
    font-weight: 500;
  }

  .code-text {
    margin-right: 4px;
  }

  .product-title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: #111827;
  }

  .product-icon {
    margin-right: 6px;
    font-size: 14px;
  }
  .product-icon.gift {
    color: #2e7d32;
  }
  .product-icon.attach {
    color: #37474f;
  }

  .product-name {
    font-size: 14px;
  }

  .product-meta {
    margin-left: 2px;
    margin-top: 2px;
  }

  .tdNote {
    width: 8%;
    font-size: 0.8125rem;
  }

  .tdAction {
    width: 1%;
    max-width: 56px;
    min-width: 52px;
    padding: 2px 0 !important;
    overflow: visible;
    text-align: center;

    .dropdown-toggle.btn,
    .dropdown-toggle.btn-sm {
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}

.selection-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  background: #fff;
  border-top: 2px solid #ffa800;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px 24px;
}

.selection-panel-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 1400px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.selection-label {
  white-space: nowrap;
  font-size: 0.88rem;
  color: #464e5f;
  flex-shrink: 0;
}

.selection-tags-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
  min-width: 0;
  max-height: 60px;
  overflow-y: auto;
}

.selection-tag {
  display: inline-flex;
  align-items: center;
  background: #fff8e8;
  border: 1px solid #ffa800;
  color: #b37700;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;

  i {
    font-size: 0.7rem;
    cursor: pointer;
    opacity: 0.6;
    &:hover { opacity: 1; }
  }
}

.selection-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
}

.selection-panel-slide-enter-active,
.selection-panel-slide-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.selection-panel-slide-enter,
.selection-panel-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
